import {Component, EventEmitter, inject, OnInit, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, SearchComponent, WmsDialogBodyComponent, WmsDialogComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent, WmsMessageComponent } from '@wms/components';
import { DialogService } from '@wms/services';
import { AddLocaleDialogComponent, AppLocaleManagerService, LocaleFormatsTabComponent, LocaleMessagesTabComponent } from '@wms/i18n';
import { WmsFeatureDirective } from '@wms/directives';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { forEach, includes, omit, uniq, pullAll, isEmpty, difference, flatMap, keys, toLower, isEqual, cloneDeep } from 'lodash-es';
import { getClonedObject, isDefined } from '@wm/core';
import { getCurrencyOptions, getDatePatterns, getTimePatterns } from '@wms/app/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FilterPipe, OrderByPipe } from '@wm/components-base';
import { PrefabManager } from '@wms/page-workspace';
import {EventManagerService} from "@wms/app";


@Component({
  selector: 'wms-locale-dialog',
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    AddLocaleDialogComponent,
    LocaleMessagesTabComponent,
    LocaleFormatsTabComponent,
    SearchComponent,
    TabsModule,
    WmsMessageComponent,
    BsDropdownModule,
    FilterPipe,
    OrderByPipe,
    WmsFeatureDirective
  ],
  providers: [AppLocaleManagerService],
  templateUrl: './locale-dialog.component.html',
  styleUrls: ['./locale-dialog.component.less']
})
export class LocaleDialogComponent extends BaseComponent implements OnInit {

  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();
  // filteredMessageList: any = [];
  isApplicationType: boolean;
  datePatterns: any = [];
  timePatterns: any = [];
  currencyOptions: any = [];
  // localeCodesMap: any = [];
  activeTabIndex: number = 0;
  appPrefabs: any = [];
  targetSearchKey: string = '';
  // projectDetails: any = {};
  // selectedPrefab: string = '';
  // filteredPrefabMessagesList: any = [];
  // private prefabMessagesList: any = [];
  private cachePrefabMessages: any = {};
  // private messagesModifiedInPrefab: any = {};
  // private filteredLocaleCodesMap: any = {};
  // private userFiles: any = {};
  // private systemFiles: any = {};
  // private userMessageKeys: any = {};
  // private userPrefabMessageKeys: any = {};
  // private newLocaleAdded: boolean = false;
  // private isDeleteRequired: boolean = false;
  // private deletedLocale: any = []
  // private systemFormatKeys: any = {};
  // private userFormatKeys: any = {};
  // private projectDefaultLanguage: string;
  // private projectProps: any = {};
  // private keyRegEx = new RegExp('^[a-zA-Z_][A-Za-z0-9_]+$');
  override eventManager: EventManagerService;

  constructor(public appLocaleService: AppLocaleManagerService, private dialogService: DialogService, private prefabManager: PrefabManager) {
    super();
    this.eventManager = inject(EventManagerService);
    this.eventManager.onModelClose().subscribe(()=>{
      this.onModalClose.emit();
    });
  }

  ngOnInit(): void {
    import('src/assets/resources/files/localeCodesMap').then(response => {
      this.appLocaleService.localeCodesMap = response.localeCodesMap;
    });
    this.appPrefabs = Object.values(this.prefabManager.appPrefabNamePropertiesMap);
    let dialogObject: any = this.dialogService.dialogs.find(dialog => dialog.id === 'appMessagesDialog');
    this.activeTabIndex = dialogObject.dialogParams.activeTab;
    this.isApplicationType = this.projectService.isApplicationType();
    this.appLocaleService.projectDefaultLanguage = this.projectService.getDetails().properties.defaultLanguage;
    this.appLocaleService.projectDetails = this.projectService.getDetails();
    this.appLocaleService.projectProps = this.appLocaleService.projectDetails.properties;
    // get date and time patterns and remove timestamp from the end
    this.datePatterns = getDatePatterns().slice(0, -1);
    this.timePatterns = getTimePatterns().slice(0, -1);
    this.currencyOptions = getCurrencyOptions();
    this.appLocaleService.toggleMessage(true, this.locale.MESSAGE_LOADING, 'loading');
    this.appLocaleService.initAppLocaleBundle();
    this.processStudioRefreshQueue();
  }

  override refreshStudio(changeSet: any): boolean {
    let isLocale = this.isLocale(changeSet);
    let isRefreshDone = false;
    if(isLocale) {
      isRefreshDone = true;
      let localeName = this.getLocaleName(changeSet);
      let isLocaleCreatedOrDeleted = this.isLocaleCreatedOrDeleted(changeSet);

      if(isLocaleCreatedOrDeleted === "ADDED" || isLocaleCreatedOrDeleted === "MODIFIED") {
        setTimeout(function (localeName: string) {
          //nothing to do for now as we are already fetching the locale bundle by calling initAppLocaleBundle
          //write any other code to refresh the locale bundle
        }, 0, localeName, this.eventManager);
      }

      if(isLocaleCreatedOrDeleted === "DELETED") {
        setTimeout(function (localeName: string) {
          //nothing to do for now as we are already fetching the locale bundle by calling initAppLocaleBundle
          //write any other code to refresh the locale bundle
        }, 0, localeName);
      }
    }
    return isRefreshDone;
  }

  getLocaleName(changeSet: any): string {
    let listOfChangesObj = changeSet.mergedFiles;
    for (const fileName in listOfChangesObj) {
      if(fileName.indexOf("i18n/") !== -1) {
        return fileName.split("i18n/")[1].split(".")[0];
      }
    }
    return "";
  }

  isLocale(changeSet: any) {
    let listOfChangesObj = changeSet?.mergedFiles;
    let isLocale = false;
    if(listOfChangesObj) {
      for (const fileName in listOfChangesObj) {
        if(fileName.indexOf("i18n/") !== -1) {
          isLocale = true;
          return isLocale;
        }
      }
    }
    return isLocale;
  }

  isLocaleCreatedOrDeleted(changeSet: any) {
    let listOfChangesObj = changeSet?.mergedFiles;
    let localeModificationFlag = "ADDED";
    if(listOfChangesObj) {
      for (const fileName in listOfChangesObj) {
        if(fileName.indexOf("i18n/") !== -1) {
          localeModificationFlag = listOfChangesObj[fileName]
          return localeModificationFlag;
        }
      }
    }
    return localeModificationFlag;
  }

  // init method - load the app-locale bundles and prepare them to display on the UI
  // initAppLocaleBundle() {
  //   (this.i18nService.getLocaleBundle() as Promise<any>).then(() => {
  //     this.appLocaleService.supportedLocale = getClonedObject(this.i18nService.supportedLocale);
  //     forEach(this.appLocaleService.supportedLocale, (locale: any) => {
  //       //load locale file
  //       let localeBundle = getClonedObject(this.i18nService.getAppLocaleBundle(locale));
  //       if (localeBundle) {
  //         this.constructModel(locale, localeBundle);
  //       }
  //     });
  //     this.constructKeyMap();
  //     this.updateFilteredLocaleCodesMap();
  //     this.appLocaleService.toggleMessage(false);
  //   }).catch((err: any) => {
  //   });
  // }

  // Prepares the messages to display on the UI.
  constructModel(locale: any, bundle: any) {
    if (this.appLocaleService.supportedLocale.length) {
      this.appLocaleService.systemMessages[locale] = {};
      forEach(bundle.systemMessages, (value: any, key: any) => {
        this.appLocaleService.systemMessages[locale][key] = value;
        this.appLocaleService.systemMessageKeys[key] = true;
      });
      this.appLocaleService.userMessages[locale] = {};
      forEach(bundle.userMessages, (value: any, key: any) => {
        this.appLocaleService.userMessages[locale][key] = value || (this.appLocaleService.userMessages.en && this.appLocaleService.userMessages.en[key]);
        this.appLocaleService.userMessageKeys[key] = true;
      });
      this.appLocaleService.userPrefabMessages[locale] = {};
      forEach(bundle.userPrefabMessages, (value: any, key: any) => {
        this.appLocaleService.userPrefabMessages[locale][key] = value || (this.appLocaleService.userPrefabMessages.en && this.appLocaleService.userPrefabMessages.en[key]);
        this.appLocaleService.userPrefabMessageKeys[key] = true;
      });
      this.appLocaleService.systemFormats[locale] = {};
      forEach(bundle.systemFormats, (value: any, key: any) => {
        this.appLocaleService.systemFormats[locale][key] = value;
        this.appLocaleService.systemFormatKeys[key] = true;
      });
      this.appLocaleService.userFormats[locale] = {};
      forEach(bundle.userFormats, (value: any, key: any) => {
        this.appLocaleService.userFormats[locale][key] = value;
        this.appLocaleService.userFormatKeys[key] = true;
      });
      this.appLocaleService.userFiles[locale] = bundle.userFiles;
      this.appLocaleService.systemFiles[locale] = bundle.systemFiles;
    }
  }

  // //constructs the key map and prepares the userMessages with the systemMessages
  // constructKeyMap() {
  //   /*maintain a unique set of keys from system and project*/
  //   this.appLocaleService.messagesList = uniq(Object.keys(this.appLocaleService.userMessages.en || {}).concat(Object.keys(this.appLocaleService.systemMessages.en || {})));
  //   this.appLocaleService.filteredMessageList = cloneDeep(this.appLocaleService.messagesList);
  //   this.appLocaleService.formatsList = uniq(Object.keys(this.appLocaleService.userFormats.en || {}).concat(Object.keys(this.appLocaleService.systemFormats.en || {})));
  //   /*merge the userMessagesModel with systemMessagesModel*/
  //   forEach(this.appLocaleService.supportedLocale, (locale: any) => {
  //     forEach(this.appLocaleService.systemMessageKeys, (value: any, key: any) => {
  //       this.appLocaleService.userMessages[locale][key] = this.appLocaleService.userMessages[locale][key] || this.appLocaleService.systemMessages[locale][key];
  //     });
  //     forEach(this.systemFormatKeys, (value: any, key: any) => {
  //       this.appLocaleService.userFormats[locale][key] = this.appLocaleService.userFormats[locale][key] || this.appLocaleService.systemFormats[locale][key];
  //     });
  //   });
  // }

  // //return a unique set of prefabMessage keys
  // getUniquePrefabMessageKeys(prefabName: any,locale: any = this.appLocaleService.selectedTempLocale.key) {
  //   this.prefabMessagesList = uniq(Object.keys(this.appLocaleService.messagesModifiedInPrefab.en[prefabName] || {}).concat(Object.keys(this.appLocaleService.messagesModifiedInPrefab[locale]?.[prefabName] || {})));
  //   this.filteredPrefabMessagesList = getClonedObject(this.prefabMessagesList);
  // }

  // updates the filteredLocaleCodesMap
  // updateFilteredLocaleCodesMap = () => {
  //   this.filteredLocaleCodesMap = omit(this.appLocaleService.localeCodesMap, this.appLocaleService.supportedLocale);
  //   this.appLocaleService.supportedLocaleCodesMap = {};
  //   forEach(this.appLocaleService.supportedLocale, (locale: any) => {
  //     if (locale === 'en') {
  //       return;
  //     }
  //     this.appLocaleService.supportedLocaleCodesMap[locale] = this.appLocaleService.localeCodesMap[locale];
  //   });
  //   if (this.appLocaleService.supportedLocale.length > 1) {
  //     this.appLocaleService.selectedTempLocale.key = (includes(this.appLocaleService.supportedLocale, this.projectDefaultLanguage) && this.projectDefaultLanguage !== 'en') ? this.projectDefaultLanguage : (this.appLocaleService.supportedLocale[0] === 'en' ? this.appLocaleService.supportedLocale[1] : this.appLocaleService.supportedLocale[0]);
  //     this.tempLocaleChanged();
  //     this.appLocaleService.multipleLocaleExists = true;
  //   } else {
  //     this.appLocaleService.multipleLocaleExists = false;
  //   }
  // }

  //to execute after add language dialog is saved
  onLocaleDialogSave(newSelectedLocale: any) {
    this.appLocaleService.deletedLocale = this.appLocaleService.deletedLocale.concat(difference(this.appLocaleService.supportedLocale, newSelectedLocale));
    /*remove the deleted locale from the supported locale map*/
    pullAll(this.appLocaleService.supportedLocale, this.appLocaleService.deletedLocale);
    if (!isEmpty(this.appLocaleService.deletedLocale)) {
      this.appLocaleService.isDeleteRequired = true;
      forEach(this.appLocaleService.userMessages, (localeObj: any, localeKey: any) => {
        if (!includes(this.appLocaleService.supportedLocale, localeKey)) {
          delete this.appLocaleService.userMessages[localeKey];
          delete this.appLocaleService.userPrefabMessages[localeKey];
          delete this.appLocaleService.systemMessages[localeKey];
        }
      });
      this.appLocaleService.updateFilteredLocaleCodesMap();
    }
    /*get the newly added languages from the dialog*/
    pullAll(newSelectedLocale, this.appLocaleService.supportedLocale);
    if (!isEmpty(newSelectedLocale)) {
      this.appLocaleService.newLocaleAdded = true;
      this.appLocaleService.toggleMessage(true, this.locale.PREPARING_MESSAGES, 'loading');
      (this.i18nService.getSystemMessages(newSelectedLocale.join(',')) as Promise<any>).then((localeBundles: any) => {
        this.updateSupportedLocale(localeBundles);
        setTimeout(()=> {
          this.appLocaleService.updateFilteredLocaleCodesMap();
          this.appLocaleService.toggleMessage(false);
        }, 300);
      }).catch((err: any) => {
        this.appLocaleService.toggleMessage(false);
      });
    }
  }

  updateSupportedLocale(localeBundles: any) {
    forEach(localeBundles, (localeObj: any) => {
      let locale = localeObj.locale,
        fallbackLocale = localeObj.systemMessagesFallbackLocale;
      /*if the system messages fallback locale is specified then just rely on the fallback locale*/
      if (fallbackLocale) {
        this.appLocaleService.systemMessages[locale] = getClonedObject(this.appLocaleService.systemMessages[fallbackLocale]);
        this.appLocaleService.userMessages[locale] = getClonedObject(this.appLocaleService.userMessages[fallbackLocale]);
        this.updatePrefabMessages(locale);

      } else {
        this.appLocaleService.systemMessages[locale] = localeObj.system.messages || getClonedObject(this.appLocaleService.systemMessages.en);
        this.updatePrefabMessages(locale);
        this.appLocaleService.userMessages[locale] = {};
        /* for a new language first prioritize the systemMessages if server has them. */
        forEach(this.appLocaleService.userMessages.en, (value: any, key: any) => {
          if (value !== this.appLocaleService.systemMessages.en[key]) {
            this.appLocaleService.userMessages[locale][key] = value;
          } else {
            this.appLocaleService.userMessages[locale][key] = this.appLocaleService.systemMessages[locale][key] || value;
          }
        });
      }
      this.appLocaleService.systemFormats[locale] = localeObj.system ? localeObj.system.formats : {};
      this.appLocaleService.userFormats[locale] = this.appLocaleService.systemFormats[locale];
      this.appLocaleService.supportedLocale.push(locale);
    });
  }

  setActiveTab(tabIndex: any) {
    this.activeTabIndex = tabIndex;
  }

  targetSearch(searchKey: any) {
    this.targetSearchKey = searchKey.searchKey
  }

  showMessages(type: any, prefabName?: any) {
    if (type === 'prefab') {
      this.appLocaleService.selectedPrefab = prefabName;
      // cachePrefabMessages- refer to messages that were updated in prefab project
      if (!this.cachePrefabMessages[prefabName]) {
        this.appLocaleService.toggleMessage(true, this.locale.PREPARING_MESSAGES, 'loading');
        (this.i18nService.getPrefabMessages(prefabName) as Promise<any>).then((prefabMessages: any) => {
          this.cachePrefabMessages[prefabName] = prefabMessages;
          this.constructPrefabMessages(prefabName, prefabMessages);
          this.appLocaleService.toggleMessage(false);
          // when search key is provided & toggled with application & prefabs
          this.searchMessages();
        }).catch(() => {
          this.appLocaleService.toggleMessage(false);
        });
      }
      else {
        this.appLocaleService.getUniquePrefabMessageKeys(prefabName);
        this.searchMessages();
      }
    }
    else {
      this.appLocaleService.selectedPrefab = '';
      this.searchMessages();
    }
  }

  tempLocaleChanged(){
    if(this.appLocaleService.selectedPrefab){
      this.appLocaleService.getUniquePrefabMessageKeys(this.appLocaleService.selectedPrefab);
    }
  }

  // prefab Messages should be populated for newly added language.
  updatePrefabMessages(locale: any) {
    forEach(this.appPrefabs, (prefab: any) => {
      if(!isEmpty(this.appLocaleService.userPrefabMessages.en[prefab.name])) {
        forEach(this.appLocaleService.userPrefabMessages.en[prefab.name], (value: any, key: any) => {
          if (!this.appLocaleService.userPrefabMessages[locale]) {
            this.appLocaleService.userPrefabMessages[locale] = {};
            this.appLocaleService.userPrefabMessages[locale][prefab.name] = {};
          }
          else if (!this.appLocaleService.userPrefabMessages[locale][prefab.name]) {
            this.appLocaleService.userPrefabMessages[locale][prefab.name] = {};
          }

          // if message is modified in prefab proj against the newly added lang, then that should be displayed.
          if (this.appLocaleService.messagesModifiedInPrefab[locale] && this.appLocaleService.messagesModifiedInPrefab[locale][prefab.name] && this.appLocaleService.messagesModifiedInPrefab[locale][prefab.name][key]) {
            // if en lang has system msg edited then that should take the priority.
            if (this.appLocaleService.userPrefabMessages['en'][prefab.name][key] !== this.appLocaleService.messagesModifiedInPrefab['en'][prefab.name][key]) {
              this.appLocaleService.userPrefabMessages[locale][prefab.name][key] = this.appLocaleService.userPrefabMessages['en'][prefab.name][key];
            }
            else {
              this.appLocaleService.userPrefabMessages[locale][prefab.name][key] = this.appLocaleService.messagesModifiedInPrefab[locale][prefab.name][key];
            }
          }
          // if en lang has system edited message then the same should be reflected for newly added language.
          else if (value !== this.appLocaleService.systemMessages.en[key]) {
            this.appLocaleService.userPrefabMessages[locale][prefab.name][key] = value;
          } else {
            this.appLocaleService.userPrefabMessages[locale][prefab.name][key] = this.appLocaleService.systemMessages[locale][key] || value;
          }
        });
      }
      else if(this.appLocaleService.messagesModifiedInPrefab[locale]?.[prefab.name]) {
        this.mergePrefabMessages(locale, prefab.name);
      }
    });
  }

  constructPrefabMessages(prefabName: string, prefabMessages: any) {
    forEach(prefabMessages, (localeObj: any) => {
      if (!this.appLocaleService.messagesModifiedInPrefab[localeObj.locale]) {
        this.appLocaleService.messagesModifiedInPrefab[localeObj.locale] = {}
      }
      this.appLocaleService.messagesModifiedInPrefab[localeObj.locale][prefabName] = localeObj.user.messages;
    });
    // populate en lang frst
    this.mergePrefabMessages('en', prefabName);
    /*merge the prefabMessagesModel with systemMessagesModel*/
    forEach(this.appLocaleService.supportedLocale, (locale: any) => {
      if (locale === 'en')
        return
      this.mergePrefabMessages(locale, prefabName);
    });
    this.appLocaleService.getUniquePrefabMessageKeys(prefabName);
  }

  mergePrefabMessages(locale: any, prefabName: any) {
    if (!this.appLocaleService.userPrefabMessages[locale]) {
      this.appLocaleService.userPrefabMessages[locale] = {};
      this.appLocaleService.userPrefabMessages[locale][prefabName] = {};
    }
    else if (!this.appLocaleService.userPrefabMessages[locale][prefabName]) {
      this.appLocaleService.userPrefabMessages[locale][prefabName] = {};
    }
    this.appLocaleService.getUniquePrefabMessageKeys(prefabName,locale);
    forEach(this.appLocaleService.prefabMessagesList, (key: any) => {
      let ModifiedMsgInEn = this.appLocaleService.messagesModifiedInPrefab.en?.[prefabName]?.[key],
        userPrefabMessage = this.appLocaleService.userPrefabMessages[locale][prefabName][key],
        msgModifiedInPrefab = this.appLocaleService.messagesModifiedInPrefab[locale]?.[prefabName]?.[key];
      this.appLocaleService.userPrefabMessages[locale][prefabName][key] = userPrefabMessage || msgModifiedInPrefab || ModifiedMsgInEn || this.appLocaleService.systemMessages[locale][key];
      if(locale!=='en' && !this.appLocaleService.userPrefabMessages['en'][prefabName][key]){
        this.appLocaleService.userPrefabMessages['en'][prefabName][key] = this.appLocaleService.systemMessages['en'][key];
      }
    });
  }

  // save the app message bundles
  // save() {
  //   let msgContent: any = {},
  //     prefabMsgContent: any = {},
  //     formatContent: any = {},
  //     bundle: any = [],
  //     invalidMsgKey: any,
  //     invalidMsgLocale;
  //
  //   if (this.appLocaleService.addInProgress) {
  //     this.add(this.appLocaleService.newMessage);
  //     return;
  //   }
  //   this.appLocaleService.supportedLocale.forEach((locale: any) => {
  //     msgContent[locale] = {};
  //     prefabMsgContent[locale] = {};
  //     formatContent[locale] = {};
  //   });
  //
  //   forEach(this.appLocaleService.messagesList, (messageKey: any) => {
  //     if (includes(this.appLocaleService.deleteList, messageKey)) {
  //       return;
  //     }
  //     this.appLocaleService.supportedLocale.forEach((locale: any) => {
  //       let userMessage = this.appLocaleService.userMessages[locale][messageKey],
  //         systemMessage = this.appLocaleService.systemMessages[locale][messageKey];
  //       if (userMessage !== systemMessage && userMessage) {
  //         msgContent[locale][messageKey] = userMessage;
  //       } else if (!isDefined(this.appLocaleService.userMessages[locale][messageKey])) {
  //         msgContent[locale][messageKey] = this.appLocaleService.userMessages.en[messageKey];
  //       } else if (!userMessage) { //if the user message doesn't exist
  //         invalidMsgKey = messageKey;
  //         invalidMsgLocale = this.appLocaleService.localeCodesMap[locale];
  //         return false;
  //       }
  //       return;
  //     });
  //     if (invalidMsgKey) {
  //       return false;
  //     }
  //     return;
  //   });
  //   this.appLocaleService.supportedLocale.forEach((locale: any) => {
  //     forEach(this.appLocaleService.userPrefabMessages[locale], (messages: any, prefabName: any) => {
  //       forEach(messages, (value: any, messageKey: any) => {
  //         if (includes(this.appLocaleService.deleteList, messageKey)) {
  //           return;
  //         }
  //         let userPrefabMessage = this.appLocaleService.userPrefabMessages[locale]?.[prefabName]?.[messageKey],
  //           systemMessage = this.appLocaleService.systemMessages[locale][messageKey],
  //           messageInPrefabProj = (this.appLocaleService.messagesModifiedInPrefab[locale]?.[prefabName]?.[messageKey]) || (this.appLocaleService.messagesModifiedInPrefab['en'] && this.appLocaleService.messagesModifiedInPrefab['en']?.[prefabName]?.[messageKey]);
  //         // this.appLocaleService.messagesModifiedInPrefab['en'][prefabName][messageKey] - for handling cases -when system messages are edited in prefab proj & on lang addition save -they shouldn't be taken
  //         if (userPrefabMessage !== systemMessage && userPrefabMessage != messageInPrefabProj && userPrefabMessage) {
  //           if (!prefabMsgContent[locale][prefabName]) {
  //             prefabMsgContent[locale][prefabName] = {};
  //           }
  //           prefabMsgContent[locale][prefabName][messageKey] = userPrefabMessage;
  //         }
  //       });
  //     });
  //   });
  //   forEach(this.appLocaleService.formatsList, (messageKey: any) => {
  //     this.appLocaleService.supportedLocale.forEach((locale: any) => {
  //       let userFormat = this.appLocaleService.userFormats[locale][messageKey],
  //         systemFormat = this.appLocaleService.systemFormats[locale][messageKey];
  //       formatContent[locale][messageKey] = userFormat || systemFormat;
  //     });
  //   });
  //
  //   if (invalidMsgKey) {
  //     this.appLocaleService.toggleMessage(true, this.locale.LABEL_APP_DEFAULT_MESSAGE_VALUE + ' for ' + invalidMsgKey + ' in ' + invalidMsgLocale + ' language : ' + this.locale.LABEL_APP_MESSAGE_ERROR_EMPTY, 'error');
  //     return;
  //   }
  //
  //   forEach(Object.keys(msgContent), (localeKey: any) => {
  //     bundle.push({
  //       'locale': localeKey,
  //       'user': {
  //         'messages': msgContent[localeKey],
  //         'formats': formatContent[localeKey],
  //         'files': (isEmpty(this.appLocaleService.userFiles[localeKey]) ? this.appLocaleService.systemFiles[localeKey] : this.appLocaleService.userFiles[localeKey]),
  //         'prefabMessages': prefabMsgContent[localeKey]
  //       }
  //     });
  //   });
  //
  //   /* if delete is required then first remove locale, update project settings and then save the app Locale*/
  //   if (this.appLocaleService.isDeleteRequired) {
  //     (this.removeDeletedLocale(this.appLocaleService.deletedLocale) as Promise<any>).then(() => {
  //       this.saveAppLocaleBundle(bundle);
  //     });
  //   } else {
  //     this.saveAppLocaleBundle(bundle);
  //   }
  // }

  /*checks if a message key already exists*/
  // isMessageAlreadyExists(messageKey: any) {
  //   let _userMessageKeys = flatMap(keys(this.appLocaleService.userMessageKeys), toLower),
  //     _userPrefabMessageKeys = flatMap(keys(this.appLocaleService.userPrefabMessageKeys), toLower),
  //     _systemMessageKeys = flatMap(keys(this.appLocaleService.systemMessageKeys), toLower);
  //   return includes(_userMessageKeys, messageKey) || includes(_systemMessageKeys, messageKey) || includes(_userPrefabMessageKeys, messageKey);
  // }

  //add a new message
  // add(message: any) {
  //   this.appLocaleService.toggleMessage(false);
  //   //make sure the new message to be inserted is valid in the below scenarios
  //   /*
  //    * message key cannot be empty
  //    * message key shouldn't accept specialCharacters
  //    * message key shouldn't already exist
  //    * message value must either exist in primary or secondary language
  //    * */
  //   if (isEmpty(message) || isEmpty(message.key)) {
  //     this.appLocaleService.toggleMessage(true, this.locale.LABEL_APP_MESSAGE_KEY + ': ' + this.locale.LABEL_APP_MESSAGE_ERROR_EMPTY, 'error');
  //     return;
  //   }
  //   if (!this.keyRegEx.test(message.key)) {
  //     this.appLocaleService.toggleMessage(true, this.locale.LABEL_APP_MESSAGE_KEY + ': ' + this.locale.MESSAGE_INSERT_VARIABLE_PROPERTY_PATTERN, 'error');
  //     return;
  //   }
  //   if (this.isMessageAlreadyExists(message.key.toLocaleLowerCase())) {
  //     this.appLocaleService.toggleMessage(true, this.locale.LABEL_APP_MESSAGE_KEY + ': ' + this.locale.LABEL_ALREADY_EXISTS, 'error');
  //     return;
  //   }
  //   if (!message.en && !message[this.appLocaleService.selectedTempLocale.key]) {
  //     this.appLocaleService.toggleMessage(true, this.locale.LABEL_APP_DEFAULT_MESSAGE_VALUE + ': ' + this.locale.LABEL_APP_MESSAGE_ERROR_EMPTY, 'error');
  //     return;
  //   }
  //   this.appLocaleService.userMessageKeys[message.key] = true;
  //   if (this.appLocaleService.multipleLocaleExists) {
  //     this.appLocaleService.supportedLocale.forEach((locale: any) => {
  //       this.appLocaleService.userMessages[locale][message.key] = message[locale] || message.en || message[this.appLocaleService.selectedTempLocale.key];
  //     });
  //   } else {
  //     this.appLocaleService.userMessages.en[message.key] = message.en;
  //   }
  //   this.appLocaleService.messagesList.unshift(message.key);
  //   this.appLocaleService.filteredMessageList.unshift(message.key);
  //   this.appLocaleService.addInProgress = false;
  //   this.appLocaleService.newMessage = {};
  // }

  /*remove the deleted locale from the supportedLocale variable*/
  // removeDeletedLocale(locales: any) {
  //   return new Promise<void>((res, rej) => {
  //     if (isEmpty(locales)) {
  //       res();
  //     }
  //     (this.i18nService.deleteLocale(locales.join(',')) as Promise<any>).then(() => {
  //       /*prepare the project details object and update the details as team project expects*/
  //       let projectDetailsObj = {
  //         'projectDetails': {
  //           'displayName': this.appLocaleService.projectDetails.displayName,
  //           'description': this.appLocaleService.projectDetails.description || '',
  //           'version': this.appLocaleService.projectDetails.version || '1.0',
  //           'defaultLanguage': this.appLocaleService.projectProps.defaultLanguage,
  //           'supportedLanguages': this.appLocaleService.supportedLocale.join(','),
  //           'homePage': this.appLocaleService.projectProps.homePage,
  //           'dateFormat': this.appLocaleService.projectProps.dateFormat,
  //           'timeFormat': this.appLocaleService.projectProps.timeFormat,
  //           'icon': this.appLocaleService.projectDetails.icon,
  //           'packagePrefix': this.appLocaleService.projectProps.packagePrefix,
  //           'copyright': this.appLocaleService.projectProps.copyrightMsg,
  //           'skipSwaggerCodeGen': this.appLocaleService.projectProps.skipSwaggerCodeGen
  //         }
  //       };
  //       /*Update the project service with the new details of supported locale once they're deleted*/
  //       res(this.projectService.updateDetails(projectDetailsObj));
  //     });
  //   });
  // }

  // // saves the appLocaleBundle
  // saveAppLocaleBundle(bundle: any) {
  //   (this.i18nService.saveAppLocaleBundle(bundle) as Promise<any>).then(() => {
  //     this.i18nService.getLocaleBundle();
  //     if (this.appLocaleService.newLocaleAdded || this.appLocaleService.deletedLocale.length) {
  //       this.appLocaleService.newLocaleAdded = false;
  //       this.updateAppVariable();
  //     }
  //     /*if the deleted file is open in the activeWS then just close the WS and reload files tree*/
  //     forEach(this.appLocaleService.deletedLocale, (localeCode: any) => {
  //       // $rs.$emit('close-ws', 'RESOURCE:../project/i18n/' + localeCode + '.json');
  //     });
  //     // $rs.$emit('update-files-tree');
  //     this.closeModal();
  //   });
  // }

  // // update supportedLocale app variable
  // updateAppVariable() {
  //   //wms:update-and-save-supportedLocale-variable
  //   this.eventManager.emitUpdateSupportedVar(this.appLocaleService.supportedLocale);
  // }

  addLanguage() {
    this.dialogService.open('addLocaleDialog');
  }

  searchMessages($event?: any) {
    const searchKey = $event ? $event.searchKey.trim().toLowerCase() : this.appLocaleService.messageSearchKey; // Normalize and trim search key
    this.appLocaleService.messageSearchKey = searchKey;
    const messagesList = this.appLocaleService.selectedPrefab ? this.appLocaleService.prefabMessagesList : this.appLocaleService.messagesList;
    let filteredList: any;
    if (!searchKey) {
      filteredList = getClonedObject(messagesList);
    }
    else {
      const messageMap = this.appLocaleService.selectedPrefab ? this.appLocaleService.userPrefabMessages.en[this.appLocaleService.selectedPrefab] : this.appLocaleService.userMessages.en;
      filteredList = messagesList.filter((message: any) => {
        return toLower(message).includes(searchKey) || toLower(messageMap).includes(searchKey)
      });
    }
    // Assign the filtered list based on whether a prefab is selected
    if (this.appLocaleService.selectedPrefab) {
      this.appLocaleService.filteredPrefabMessagesList = filteredList;
    } else {
      this.appLocaleService.filteredMessageList = filteredList;
    }
  }

  closeDialogWithId(id: string): void {
    this.dialogService.close(id)
  }

  // hideNewField() {
  //   this.appLocaleService.addInProgress = false;
  //   this.appLocaleService.toggleMessage(false);
  // }
  //
  // closeModal() {
  //   if (this.appLocaleService.addInProgress) {
  //     this.hideNewField();
  //     return;
  //   }
  //   this.onModalClose.emit();
  // }
}
